import { Game } from "./modules/@denishussar/html5-game-engine";
import { ScreenOrientationEnum } from "./modules/@denishussar/html5-game-engine";
import { EnvironmentTypeEnum } from "./modules/@denishussar/html5-game-engine";
import { GameInstance } from "./Game/GameInstance";
import { Settings } from "./settings";
import * as WebFont from 'webfontloader';

declare var require;

require("../fonts/fonts.css");
const gameCfg = require('../game-config.json');
const version = require('./../package.json').version;

export default class main {
    constructor() {
        WebFont.load({
            custom: {
                families: [
                    'Times New Roman',
                    'Arial Black',
                    'Montserrat',
                    'Myriad Pro',
                    'MyriadPro-Regular',
                    'MyriadPro-Bold',
                ],
            },
            loading: () => {
                this.startGame();
            }
        });

    }
    public startGame(): Game {
        return new Game({
            main: GameInstance,
            version: version,
            sounds: [
                {
                    "id": "button",
                    "path": "/sounds/button.mp3"
                },
                {
                    "id": "button_disabled",
                    "path": "/sounds/button_disabled.mp3"
                },
                {
                    "id": "Jump",
                    "path": "/sounds/Jump.mp3"
                },
                {
                    "id": "Jump_Spin",
                    "path": "/sounds/Jump_Spin.mp3"
                },
                {
                    "id": "Jump_Spin",
                    "path": "/sounds/Jump_Spin.mp3"
                },
                {
                    "id": "Metal_Hit",
                    "path": "/sounds/Metal_Hit.mp3"
                },
                {
                    "id": "Wooden_Hit",
                    "path": "/sounds/Wooden_Hit.mp3"
                },
                {
                    "id": "Crowd_1",
                    "path": "/sounds/Crowd_1.mp3"
                },
                {
                    "id": "Crowd_2",
                    "path": "/sounds/Crowd_2.mp3"
                },
                {
                    "id": "Crowd_3",
                    "path": "/sounds/Crowd_3.mp3"
                },
                {
                    "id": "Footstep_1",
                    "path": "/sounds/Footstep_1.mp3"
                },
                {
                    "id": "Footstep_2",
                    "path": "/sounds/Footstep_2.mp3"
                },
                {
                    "id": "menu_music",
                    "path": "/sounds/menu_music.mp3"
                },
                {
                    "id": "game_music",
                    "path": "/sounds/game_music.mp3"
                },
                {
                    "id": "game_music_fon",
                    "path": "/sounds/game_music_fon.mp3"
                },
                {
                    "id": "new_record",
                    "path": "/sounds/new_record.mp3"
                },
            ],
            assetsRoot: gameCfg.resourcesRoot,
            elementId: "gamePlace",
            noWebGL: false,
            backgroundColor: 0x89C0FC,
            clearBeforeRender: true,
            transparent: false,
            showStats: false,
            disableContextMenu: true,
            antialias: false,
            fps: 60,
            gameId: gameCfg.gameId,
            orientations: [
                // {
                //     orientation:ScreenOrientationEnum.Portrait,
                //     orientationEnvironment: EnvironmentTypeEnum.phone
                // },
                {
                    orientation: ScreenOrientationEnum.PortraitAndLandscape,
                    orientationEnvironment: EnvironmentTypeEnum.pc | EnvironmentTypeEnum.tablet | EnvironmentTypeEnum.phone
                }
            ]
        });
    }

}



